<template>
    <div class="carTraffic">
        <h2>{{$t('traffic_system')}}</h2>
        <div class="traffic_search">
            <input type="text" v-model="mapSearch" :placeholder="$t('placeholder_location')" id="search">
            <div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
            <input type="text" :value="$t('name')" readonly class="txt">
            <span class="search_btn" @click="searchMap()"></span>
        </div>
        <div class="map-show">
            <div id="l-map"></div>
            <div id="r-result" ></div>
        </div>
        <h2>{{$t('traffic_type[0]')}}</h2>
        <trafficRoute :traffic_route="n" v-for="(n,i) in busTraffic_route" :key="i"></trafficRoute>
    </div>
</template>

<script>
    import trafficRoute from './trafficRoute';
    export default {
        name: "carTraffic",
        props:['busTraffic_route'],
        components: {
            trafficRoute
        },
        data (){
          return {
              mapSearch:'',
              mapValue: '',
              keyword_Search:''
          }
        },
        mounted(){
            this.map();
            const  that =this;
            this.keyword_Search.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
                var _value = e.item.value;
                that.mapSearch = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                document.getElementById("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br /> ";
                that.searchMap();
            });
        },
        methods:{
            map() {
                this.mapValue = new BMap.Map("l-map");
                var point = new BMap.Point(113.29631,22.884312);
                this.mapValue.centerAndZoom(point, 13);
                this.mapValue.enableScrollWheelZoom();//启动鼠标滚轮缩放地图
                this.mapValue.enableKeyboard();//启动键盘操作地图

                this.keyword_Search = new BMap.Autocomplete(    //建立一个自动完成的对象
                    {
                        "input": 'search',
                        "location": this.mapValue
                    });

                var marker = new BMap.Marker(point);  // 创建标注
                this.mapValue.addOverlay(marker);              // 将标注添加到地图中
                var label = new BMap.Label(this.$t('name'), {offset: new BMap.Size(20, -10)});
                marker.setLabel(label);
            },
            searchMap() {
                var driving = new BMap.DrivingRoute(this.mapValue, {
                    renderOptions: {
                        map: this.mapValue,
                        panel: "r-result",
                        autoViewport: true
                    }
                });
                driving.search(this.mapSearch, "长鹿旅游休博园");
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';
    .carTraffic {
        width: @width;
        h2 {
            line-height: 24px;
            margin: 10px auto;
        }
        .traffic_search {
            height: 72px;
            background: @bg;
            .box-sizing;
            width: @width;
            padding: 0 30px;
            position: relative;
            margin-bottom: 20px;
            &:before{
                content: '';
                width: 30px;
            }
            &:before {
                top: 0;
                left: 0;
                height: @width;
                background: url(../../assets/images/service/traffic_03.png) no-repeat 9px 15px;
                background-size: 8px auto;

            }
           .search_btn{
                position: absolute;
                top: 9px;
                right: 4px;
                height: 40px;
                width: 30px;
                display: block;
                background: url(../../assets/images/service/service_sprite.png)no-repeat  -6px -75px;
                background-size: 40px auto;
            }
            input {
                width: @width - 5;
                height: calc(50% - 1px);
                background: @bg;
                font-size: .9rem;
                .border-bottom;
                &.txt {
                    border-bottom: none;
                }
            }

        }
    }
    .map-show {
        width: @width;
        height: auto;
        .box-sizing;
        /*padding: 0 20px;*/
        .border-bottom;
        padding-bottom: 20px;
    }

    #l-map {
        height: 150px;
    }
  @media (min-width: 768px) and (orientation: portrait){
      #l-map {
        height: 235px;
      }
  }
</style>
